 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Policy
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryPolicyFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            v-model="filtersPolicy.polNo"
                            :label="filtersPolicyLabel.polNo"
                            :error-messages="errors.collect('filtersPolicy.polNo')"
                            data-vv-name="filtersPolicy.polNo"
                            :data-vv-as="filtersPolicyLabel.polNo"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearPolicyFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doPolicyFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="polHeaders"
          :items="polItems"
          v-bind:options.sync="paginationPolicy"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsPol"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.polNo }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignPolicy(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      filtersPolicyLabel: {
        polNo: 'Policy'
      },
      filtersPolicy: {
        polNo: undefined
      },
      polItems: [],
      totalItemsPol: 0,
      polHeaders: [
        { text: 'Policy No.', align: 'left', value: 'polNo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationPolicy: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.doClearPolicyFilters()
  },
  methods: {
    closeDialog() {
      this.filtersPolicy.polNo = ''
      this.$emit('close')
    },
    doClearPolicyFilters() {
      this.filtersPolicy.polNo = ''
      this.fetchPolicyData2()
    },
    doPolicyFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryPolicyFilterForm').then((result) => {
        if (result) {
          this.paginationPolicy.page = 1
          this.fetchPolicyData2()
        }
      })
    },
    assignPolicy(data) {
      this.$emit('assign-policy-info', data)
      this.$emit('close')
    }
  },
  watch: {
    boolRefresh: function (value) {
      this.doClearPolicyFilters()
    },
    'paginationPolicy': function (value) {
      this.fetchPolicyData2()
    }
  },
  computed: {
    menu() {
      return this.$store.state.commons.menu
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
